/**
 * Keeps the ".preorder-note" message in sync when the customer switches variants.
 *
 * Horizon's product form only morphs the add-to-cart button element itself on
 * 'variant:update' (see product-form.js), so a sibling element like the preorder
 * note would otherwise go stale. This listener uses the fresh section HTML the
 * theme already fetched for the update and adds/replaces/removes the note.
 */
document.addEventListener('variant:update', (event) => {
  const html = event.detail?.data?.html;
  if (!html) return;

  const target = event.target;
  const scope =
    target instanceof Element ? target.closest('.shopify-section, dialog, product-card') || document : document;

  const newNote = html.querySelector('.preorder-note');
  const productId = event.detail?.data?.productId;

  scope.querySelectorAll('product-form-component').forEach((form) => {
    if (productId && form.dataset.productId && form.dataset.productId !== productId) return;

    const container = form.querySelector('add-to-cart-component');
    if (!container) return;

    const currentNote = form.querySelector('.preorder-note');

    if (currentNote && newNote) {
      currentNote.replaceWith(newNote.cloneNode(true));
    } else if (currentNote && !newNote) {
      currentNote.remove();
    } else if (!currentNote && newNote) {
      container.insertAdjacentElement('afterend', newNote.cloneNode(true));
    }
  });
});
